module.exports = __webpack_public_path__ + "images/3-ia8ef0105a369f5171a87f9b35a24ffd0.svg";